interface ISiteFilterSingle 
    extends ISiteFilter{
    
    getValue(): string;
    setValue(value?: string): void;
}

class SiteFilterSingleValue
    implements ISiteFilterSingle {

    private readonly _name: string;
    private _value: string;

    constructor(name: string, value: string) {
        this._name = name;
        this._value = value;
    }

    getValue(): string {
        return this._value || "";
    }
    getName(): string {
        return this._name;
    }
    setValue(value: string): void {
        this._value = value;
    }
    setContent(values: ISiteFilterItem) {
        
    }
    hasValue(): boolean {
        return this._value.length != 0;
    }
    removeValue(): void {
        //this._value = "";
    }

}

class SiteElementFilterSingle
    extends SiteElementFilter
    implements ISiteFilterSingle {
    
    private _value: string;
    private _renderer?: ISiteElementFilterRendererQueryElement;

    constructor(element:HTMLElement, site: SiteAssortment) {
        super(element, site);

        this._value = "";
        this._renderer = undefined;
    }
    
    getValue(): string {
        return this._value;
    }
    hasValue(): boolean {
        return this._value.length != 0;
    }
    removeValue(): void {
        this._value = "";
    }
    setValue(value: string) {
        this._value = value;
    }
    clearFilterModel(): void {
        this.getSite().clearFilterModel();
    }
    updateFilterModel(updateAll: boolean): void {
        this.getSite().updateFilterModel(this,
            updateAll ? [] : [this.getName()]
        );
    }

    setContent(value: ISiteFilterItem): void {
        // -- Create new renderer
        let renderer: ISiteElementFilterRendererQueryElement;

        let state: any;
        if (this._renderer != null)
            state = this._renderer.getState();

        switch(this.getAttr("data-renderer"))
        {
            default:
            case "Input":
                renderer = this._renderer || new SiteElementFilterSingleInputRenderer(this, value);
                break;
            case "ArticleGroup":
                renderer = new SiteElementFilterSingleArticleGroupRenderer(this, value, this.getSite());
                break;
            case "Dropdown":
                renderer = new SiteElementFilterSingleDropdownRenderer(this, value);
                break;
        }
        
        if (this._renderer != renderer) {
            // -- Remove old renderer
            if (this._renderer != null)
                this._renderer.remove();
            
            // -- Append new renderer
            this.append(renderer);

            // Add renderer reference:
            this._renderer = renderer;
        }
    }
}